module.exports = __webpack_public_path__ + "static/media/15.c19c55f.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/15.wav
// module id = fExL
// module chunks = 0